import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-virtual-necklace"
    exact
    path="/business/products/ai-virtual-necklace"
    component={AsyncPage}
  />,
];
